import { render, staticRenderFns } from "./IndexEight.vue?vue&type=template&id=0b988dc0&"
import script from "./IndexEight.vue?vue&type=script&lang=js&"
export * from "./IndexEight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports